
import AppBrowseActions from "@/components/browse/BrowseActions.vue";
import AppBrowseTable from "@/components/browse/BrowseTable.vue";
import AppBrowseTotalItemsResult from "@/components/browse/BrowseTotalItemsResult.vue";
import AppFilterModal from "@/components/browse/FilterModal.vue";
import AppCustomReportCreate from "@/components/reportengine/CreateCard.vue";
import AppBrowseTotals from "@/components/browse/BrowseTotals.vue";
import AppBrowseSelectionTotals from "@/components/browse/BrowseSelectionTotals.vue";
import { ViewSetting } from "@/models/user-configs/view-setting";
import { IBrowseDataSource } from "@/utils/browse/browse-data-source";
import { BrowseState } from "@/utils/browse/browse-state";
import AppExtraFieldQuickEdit from "@/components/browse/ExtraFieldQuickEdit.vue";
import AppExtraFieldQuickEditFieldSelect from "@/components/browse/ExtraFieldQuickEditFieldSelect.vue";
import AppUploadDocumentModal from "@/components/aws-files-modules/UploadDocumentModal.vue";
import AppEditExtraFieldsModal from "@/components/ExtraFieldsEditModal.vue";
import AppScriptArgsInputModal from "@/components/scripts/ScriptArgInputsModal.vue";
import AppBrowseToFileModal from "./BrowseToFileModal.vue";
import AppPrintLabelsModal from "./PrintLabelsModal.vue";
import AppBrowseInlineIframe from "./BrowseInlineIframe.vue";
import AppBrowseSidebar from "./BrowseSidebar.vue";

import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";
import { eventBus } from "winfakt-vue-components/src/event-bus";
import { View } from "@/models/view";
import { BrowserInfo } from "@/utils/browser";
import { IExtraFieldQuickEditViaMenuDataResult } from "@/utils/models/extra-fields";
import { ScannerListener } from "@/utils/scanner";
import { IQueryFilters } from "@/utils/query-params";
import { HumanFilter } from "@/services";

export default Vue.extend({
	data() {
		return {
			initialized: false,
			state: null as any as BrowseState,
			browseID: 0,
			searchKeyPressedWasScanner: false,
			isScannerListening: false
		};
	},
	props: {
		dataSource: {
			type: Object as () => IBrowseDataSource<any>,
			required: true
		},
		selectedItems: {
			type: Array as () => any[],
			required: true
		},
		controlsDisabled: Boolean,
		searchEnabled: Boolean,
		buttonBarItems: {
			type: Array as () => ISelectItem<any>[],
			default: ()=>[]
		},
		urlQueryParams: Boolean,
		contextMenuItems: {
			type: Array as () => ISelectItem<string>[],
			default: () => []
		},
		view: Object as ()=>View,
		deleteMessageKey: String,
		editButtonsHidden: Boolean,
		ignoreScanner: Boolean
	},
	computed: {
		isSafari():boolean{
			return BrowserInfo.isSafari();
		}
	},
	watch: {
		buttonBarItems() {
			if (this.state) {
				this.state.baseButtonBarItems = this.buttonBarItems;
			}
		},
		contextMenuItems() {
			if (this.state) {
				this.state.contextMenu.items = this.contextMenuItems;
			}
		},
		"state.queryResults.data.length"(){
			this.state.checkIfSelectedItemsAreStillInBrowse();
		},
		selectedItems(){
			if (!this.state) return;
			this.state.onSelectionChanged();
		},
		"state.querySettings.view.ID"(){
			if (!this.state) return;
			this.state.onViewChanged();
		},
		editButtonsHidden: {
			handler(){
				this.state.editButtonsHidden = this.editButtonsHidden;
			}
		},
		"$route.query.filters": {
			handler(){
				if (!this.urlQueryParams) return;
				if (!this.$route.query) return;
				if (!this.$route.query.filters) return;
				if (this.$route.query.filters == "") return;
				let filters:IQueryFilters = JSON.parse(this.$route.query.filters.toString()) || {};
				filters.filters = (filters.filters || []).map(f=>new HumanFilter(f));
				this.state.setFilters(filters);
				this.refresh();
			}
		},
		"state.quickSearchFocused": {
			handler(){
				this.updateScannerState();
			}
		}
	},
	methods: {
		async init() {
			this.initialized = false;
			let result = await this.dataSource.getSettings();
			this.browseID = result.browse.ID;
			if (!result.viewSetting) {
				result.viewSetting = ViewSetting.getDefaultViewSetting();
			}
			try {
				this.state = new BrowseState(this, this.dataSource, result, this.urlQueryParams, this.selectedItems);
				this.state.controlsDisabled = this.controlsDisabled;
				this.state.searchEnabled = this.searchEnabled;
				this.state.baseButtonBarItems = this.buttonBarItems;
				this.state.contextMenu.items = this.contextMenuItems;
				this.state.editButtonsHidden = this.editButtonsHidden;
				this.state.fetch();
				this.initSubscribeOnEvents();
				if (this.view) {
					this.state.setStaticView(this.view);
				}
				this.initialized = true;
				this.$emit("state", this.state);
				this.updateScannerState();
			} catch (err:any) {
				if (err.message == "no-views") {
					this.noViewsDialog();
				} else {
					this.showError(err);
				}
			}
		},
		updateScannerState(){
			if (!this.state) return;
			if (this.$wf.isModalOpen(this) || this.state.quickSearchFocused || this.ignoreScanner){
				this.isScannerListening = false;
				ScannerListener.offInput(this.onScannerInput);
				return;
			}

			if (!this.isScannerListening){
				this.isScannerListening = true;
				ScannerListener.onInput(this.onScannerInput);
			}
		},

		initSubscribeOnEvents(){
			this.state.on("delete", this.delete);
			this.state.on("button-bar-trigger", (value: string) => {
				this.$emit("button-bar-trigger", value);
				this.$emit(value, this.state.selectedItems[0]);
			});
			this.state.on("context-menu-trigger", (item: { value: string, item: any }) => {
				this.$emit("context-menu-trigger", item.value, item.item);
				this.$emit(item.value, item.item);
			});
			this.state.on("col-click-result", (result:string, value:any)=>{
				this.$emit("col-click-result", result, value);
			});
			this.state.on("context-menu-item", (item:any)=>{
				this.$emit("context-menu-item", item);
			});
		},

		async noViewsDialog() {
			let confirm = await this.$wf.confirm(this.$ct("error-no-views-create"), this.$t("common.yes"), this.$t("common.no"));
			if (confirm) {
				this.$router.push(`/settings/browse/${this.browseID}/view/new`);
			} else {
				this.showError(new Error(this.$ct("error-no-views").toString()));
				this.$router.push("/");
			}
		},

		showError(err: Error) {
			this.$wf.notify(err.message, "danger", 3000, "exclamation-triangle");
		},
		// eslint-disable-next-line max-lines-per-function
		async searchKeyPressed(e: KeyboardEvent) {
			if (!this.state) return;
			if (this.$wf.isModalOpen(this)) return;

			let target = e.target as HTMLElement;
			if (target.isContentEditable || (typeof target.className === "string" && target.className.indexOf("w-input") >= 0)) {
				return;
			}

			if ((e.ctrlKey || e.metaKey) && e.keyCode == 86) {
				this.state.querySettings.searchQuery = "";
				this.state.showSearch = true;
				return;
			}

			if (e.altKey || e.ctrlKey || e.metaKey)
				return;

			if (e.keyCode == 27) {
				this.state.showSearch = false;
				return;
			}

			if (!/^[a-zA-Z0-9-_]$/.test(e.key)) return;

			if (!this.state.showSearch && document.getElementsByClassName("modal").length) return;

			if (await this.searchKeyWasScanner()) return;
			console.log("Search key was not scanner");
			e.preventDefault();

			if (!this.state.showSearch) {
				this.state.querySettings.searchQuery = e.key;
				this.state.showSearch = true;
			} else {
				this.state.querySettings.searchQuery = (this.state.querySettings.searchQuery || "") + e.key;
			}
		},
		async searchKeyWasScanner(): Promise<boolean> {
			console.log("Checking search key");
			if (this.searchKeyPressedWasScanner) return true;
			await new Promise(resolve=>setTimeout(resolve, 200));
			if (this.searchKeyPressedWasScanner) {
				console.log("Search key was scanner");
				return true;
			}
			return false;
		},
		async delete() {
			if (!this.state) return;
			let confirmTextKey = this.deleteMessageKey || "deleteConfirm";
			let itemCount = this.selectedItems.length;
			let confirmText = this.$ctc(confirmTextKey, itemCount, {amount: itemCount});
			let confirm = await this.$confirmBuilder(confirmText).setWarningTitle().show();
			if (confirm) {
				let updateView = await this.dataSource.delete(this.selectedItems);
				if (updateView){
					this.selectedItems.splice(0, this.selectedItems.length);
					await this.state.fetch();
				}
			}
		},
		refresh(){
			if (!this.state) return;
			this.state.fetch();
		},
		async setExtraFieldsQuickEditValue(value: IExtraFieldQuickEditViaMenuDataResult, callback: Function){
			await this.state.setExtraFieldQuickEditValue(value, callback);
		},
		async onScannerInput(input:string){
			console.log("On scanner input");
			this.searchKeyPressedWasScanner = true;
			setTimeout(()=>{
				this.searchKeyPressedWasScanner = false;
			}, 200);
			if (this.ignoreScanner) return;
			this.state.quickSearch = input;
			this.state.querySettings.searchQuery = this.state.quickSearch;
			await this.state.fetch();
		}
	},
	mounted() {
		this.init();
	},
	created() {
		eventBus.on("modal", this.updateScannerState);
		window.addEventListener("keydown", this.searchKeyPressed);
	},
	destroyed() {
		eventBus.off("modal", this.updateScannerState);
		window.removeEventListener("keydown", this.searchKeyPressed);
		ScannerListener.offInput(this.onScannerInput);
		if (!this.state) return;
	},
	components: {
		AppBrowseActions,
		AppBrowseTable,
		AppBrowseTotalItemsResult,
		AppFilterModal,
		AppCustomReportCreate,
		AppBrowseTotals,
		AppBrowseSelectionTotals,
		AppExtraFieldQuickEdit,
		AppExtraFieldQuickEditFieldSelect,
		AppUploadDocumentModal,
		AppEditExtraFieldsModal,
		AppScriptArgsInputModal,
		AppBrowseToFileModal,
		AppPrintLabelsModal,
		AppBrowseInlineIframe,
		AppBrowseSidebar
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
